import React from 'react';
import { IconProps } from '../../types/icon';

const PptIcon: React.FC<IconProps> = ({ className, size = 16 }) => {
  return (
    <img
      src="/gitex-illustrations/PptIcon.png"
      alt="PowerPoint"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default PptIcon;